module.exports = __webpack_public_path__ + "static/media/act.d757211c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/List/act.png
// module id = 541
// module chunks = 0